//
// Module for Fund Setup Index view
//
rs.module("fund/configuration/fundsetup",

    [
        "common/select-helper",
        "common/visibility"
    ],

    function (selectHelper, visibility) {

        // Initialize the module
        function initialize(jsSelectors, variableType) {

            // Unpack js selectors
            var form = $.js(jsSelectors.form);

            var currentFiscalYearSection = form.js(jsSelectors.currentFiscalYearSection);

            var fiscalYearTypeSelect = form.js(jsSelectors.fiscalYearTypeSelector);
            var currentFiscalYearInput = form.js(jsSelectors.currentFiscalYearInput);

            // Get select helper(s) for working with select lists
            var fiscalYearTypeSelectHelper = selectHelper.getHelper(fiscalYearTypeSelect);

            // Setup on change event
            fiscalYearTypeSelect.change(fiscalYearTypeSelected);

            // On Fiscal Year Type selection change, show / hide the Current Fiscal Year field
            function fiscalYearTypeSelected() {

                // Hide field
                visibility.hide(currentFiscalYearSection);
                currentFiscalYearInput.val('').clearErrors();

                if (fiscalYearTypeSelect.val() == variableType) {
                    // Show the field
                    visibility.show(currentFiscalYearSection);
                }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);